import {
  COMMON,
  type CommonProps,
  type FlexProps,
  type LayoutProps,
} from '#app/theme/constants.js';
import { FLEX, LAYOUT } from '#app/theme/index.js';
import { sx, type SXProps } from '#app/theme/utils.js';
import { StyledTextFieldInput } from './StyledTextFieldInput.js';
import { TextFieldInputItems } from './StyledTextFieldInputItems.js';
import { StyledTextFieldTextArea } from './StyledTextFieldTextArea.js';
import { css, styled } from 'styled-components';

type StyledTextFieldInputGroupProps = CommonProps &
  FlexProps &
  LayoutProps &
  SXProps & {
    $skipMargins?: boolean;
  };

export const StyledTextFieldInputGroup = styled.div<StyledTextFieldInputGroupProps>`
  ${({ $skipMargins = false }) => css`
    display: flex;
    align-items: center;
    min-height: 40px;
    padding-bottom: 2px;

    ${$skipMargins
      ? ''
      : css`
          &
            > *:not(${StyledTextFieldInput}):not(
              ${StyledTextFieldTextArea}
            ):not(${TextFieldInputItems}) {
            margin-left: 4px;
            margin-right: 4px;

            &:first-child {
              margin-left: 16px;
            }

            &:last-child {
              margin-right: 16px;
            }
          }
        `}

    &[aria-disabled='true'] {
      cursor: not-allowed;
    }

    ${COMMON}
    ${FLEX}
      ${LAYOUT}
      ${sx}
  `}
`;

StyledTextFieldInputGroup.displayName = 'TextField.InputGroup';
